import React from "react";
import { bind } from "decko";

import Util from "./include/Util";
import DialogOverlay from "./DialogOverlay";
import L1PlayerSelector from "./L1PlayerSelector";
import KeeperSelector from "./KeeperSelector";

/**
 * UI for creating a goal event, selecting home/away team and updating score
 */
export default class GoalEventDialog extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            selectedTeam: this.props.selectedTeam,
            homeTeamGoals: this.props.homeTeamGoals,
            visitingTeamGoals: this.props.visitingTeamGoals,
            player: null,
            keeper: null,
        };
        if (this.props.selectedTeam.id === this.props.homeTeam.id) {
            this.state.homeTeamGoals++;
            this.state.keeper = this.props.visitingTeamKeeper;
        } else {
            this.state.visitingTeamGoals++;
            this.state.keeper = this.props.homeTeamKeeper;
        }
    }

    getTag () {
        let tag = {
            action: "goal",
            team: {
                type: "team",
                id: this.state.selectedTeam.id,
                value: this.state.selectedTeam.name
            },
        };
        if (this.state.player !== null) {
            tag.scorer = {
                type: "player",
                id: this.state.player.id,
                value: this.state.player.value
            };
        }
        if (this.state.keeper !== null && this.state.keeper.id !== null) {
            tag.keeper = {
                type: "player",
                id: this.state.keeper.id,
                value: this.state.keeper.value
            };
        }
        return tag;
    }

    getScore () {
        return [this.state.homeTeamGoals, this.state.visitingTeamGoals];
    }

    getDescription (tag) {
        if (tag === undefined) tag = this.getTag();

        return Util.createAutomaticTitle(tag, this.props.game, this.getScore());
    }

    @bind
    save () {
        let tag = this.getTag();
        this.props.onSave(tag, this.getScore(), this.getDescription(tag));
    }

    @bind
    selectPlayer (player) {
        this.setState({player: player});
    }

    @bind
    selectKeeper (keeper) {
        this.setState({keeper: keeper});
    }

    render () {

        return (
            <DialogOverlay
                hotkeyHandler={this.props.hotkeyHandler}
                onSubmit={this.save}
                onCancel={this.props.onCancel}>

                <div className="row" style={{marginBottom: "16px"}}>
                    <div className="col-xs-12 text-center text-capitalize">
                        {this.getDescription()}
                    </div>
                    <div className="col-xs-12 text-center">
                        <div className="col-xs-6 text-center">
                            {this.props.homeTeam.name}
                        </div>
                        <div className="col-xs-6 text-center">
                            {this.props.visitingTeam.name}
                        </div>
                    </div>
                    <div className="col-xs-12" style={{marginTop: "10px"}}>
                        <div className="text-center">
                            <div className="col-xs-offset-1 col-xs-4">
                                {this.state.homeTeamGoals}
                            </div>
                            <div className="col-xs-2">
                                :
                            </div>
                            <div className="col-xs-4">
                                {this.state.visitingTeamGoals}
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 text-center" style={{marginTop: "10px"}}>
                        <L1PlayerSelector
                            player={this.state.player}
                            lineup={this.props.lineup}
                            playersOnPitch={this.props.playersOnPitch}
                            playersUnavailable={this.props.playersUnavailable}
                            selectedTeam={this.state.selectedTeam}
                            onChange={this.selectPlayer}
                        />
                    </div>
                    <KeeperSelector
                        lineup={this.props.lineup}
                        keeper={this.state.keeper}
                        team={
                            this.state.selectedTeam.id === this.props.homeTeam.id ?
                                this.props.visitingTeam : this.props.homeTeam
                        }
                        onKeeperSelected={this.selectKeeper}
                    />
                </div>
            </DialogOverlay>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/GoalEventDialog.js